module.exports = __webpack_public_path__ + "dashboard/img/pause.5b29889bc99c735a44eb946ea7a739c7.svg";